import React, { useEffect, useState, useCallback } from "react";
import { surahData } from "../data/surahData";
import { saveStudentProgress } from "../services/firestoreService";
import "./StudentDetails.css";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../services/firebase";
import { getInitials, customStyles } from "../utils/commonUtils";
import Select from "react-select";
import { toast } from "react-toastify";
import { mergeManualWithRealStudent } from "../services/firestoreService";
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
import { MdOutlineCallMerge, MdOutlinePictureAsPdf } from "react-icons/md";
import { generateStudentPDF } from "../utils/pdfUtils";




const StudentDetails = ({ student, onBack, onUpdate }) => {
    const [progressForm, setProgressForm] = useState({ endAyah: "" });
    const [teacherName, setTeacherName] = useState("");
    const [juz, setJuz] = useState("Juz 1");
    const [lastProgress, setLastProgress] = useState(null);
    const [schoolName, setSchoolName] = useState("Unknown School");
    const [classroomName, setClassroomName] = useState("Unknown Classroom");
    const [isCustomStart, setIsCustomStart] = useState(false);
    const [customSurahIndex, setCustomSurahIndex] = useState(0);
    const [customStartAyah, setCustomStartAyah] = useState(1);

    const now = new Date();
    const date = `${String(now.getDate()).padStart(2, "0")}/${String(now.getMonth() + 1).padStart(2, "0")}/${now.getFullYear()}`;
    const [activeTab, setActiveTab] = useState("rekod");
    const [openAccordion, setOpenAccordion] = useState(null);
    const [touchStartX, setTouchStartX] = useState(null);
    const [isGeneratingPdf, setIsGeneratingPdf] = useState(false);


    const fetchInitialData = useCallback(async () => {

        // Fetch teacher name
        if (student.classroomId) {
            try {
                const classroomRef = doc(db, "schools", student.schoolId, "classrooms", student.classroomId);
                const classroomSnap = await getDoc(classroomRef);

                if (classroomSnap.exists()) {
                    const classroomData = classroomSnap.data();
                    setClassroomName(classroomData.name || "Unknown Classroom");

                    const currentUser = JSON.parse(localStorage.getItem("user"));
                    setTeacherName(currentUser?.name || "Unknown Teacher");

                }
            } catch (error) {
                console.error("Error fetching classroom data:", error);
            }
        }

        // Fetch school name
        if (student.schoolId) {
            try {
                const schoolRef = doc(db, "schools", student.schoolId);
                const schoolSnap = await getDoc(schoolRef);

                if (schoolSnap.exists()) {
                    setSchoolName(schoolSnap.data().name || "Unknown School");
                }
            } catch (error) {
                console.error("Error fetching school data:", error);
            }
        }

        // Handle student progress (already implemented)
        if (student.progress?.length > 0) {
            const lastProgress = student.progress[student.progress.length - 1];
            const surah = surahData.find((s) => s.name === lastProgress.surah);

            if (surah) {
                const matchingJuz = surah.juz.find(
                    (j) => lastProgress.endAyah >= j.startAyah && lastProgress.endAyah <= j.endAyah
                );
                setJuz(matchingJuz ? `Juz ${matchingJuz.number}` : "Unknown");
                setLastProgress(lastProgress);
            }
        }
    }, [student]);



    useEffect(() => {
        if (student) {
            fetchInitialData();
        }


    }, [student, fetchInitialData]);




    const handleSaveProgress = async (e) => {
        e.preventDefault();

        const endAyah = Number(e.target.elements.endAyah.value);
        const ulasan = progressForm.ulasan?.trim() || "Bacaan yang baik";

        const isFirstTime = !student.progress?.length;
        const useCustom = isCustomStart && isFirstTime;

        const surahIndex = useCustom ? customSurahIndex : student.currentSurahIndex;
        const startAyah = useCustom ? customStartAyah : student.startAyah;
        const totalAyahs = surahData[surahIndex].totalAyahs;
        const surahName = surahData[surahIndex].name;
        const nowTime = new Date();
        const formattedTime = nowTime.toLocaleTimeString("ms-MY", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false
        });


        if (!endAyah || endAyah < startAyah || endAyah > totalAyahs) {
            toast.warn(`Ayat tidak sah! Masukkan antara ${startAyah} hingga ${totalAyahs}.`);
            return;
        }

        const progress = {
            surah: surahName,
            startAyah,
            endAyah,
            ulasan,
            date,
            time: formattedTime,
            guru: teacherName,
        };

        try {
            await saveStudentProgress(student.id, progress);

            const nextAyah = endAyah + 1;
            const isSurahComplete = nextAyah > totalAyahs;


            if (useCustom) {
                student.currentSurahIndex = customSurahIndex;
                student.startAyah = customStartAyah;
            }

            student.currentSurahIndex = isSurahComplete
                ? student.currentSurahIndex + 1
                : student.currentSurahIndex;

            student.startAyah = isSurahComplete ? 1 : nextAyah;

            if (!student.progress) student.progress = [];
            student.progress.push(progress);

            const surah = surahData.find((s) => s.name === progress.surah);
            const matchingJuz = surah?.juz.find(
                (j) => progress.endAyah >= j.startAyah && progress.endAyah <= j.endAyah
            );

            setJuz(matchingJuz ? `Juz ${matchingJuz.number}` : "Unknown");
            setLastProgress(progress);
            setProgressForm({ endAyah: "", ulasan: "" });

            toast.success(`Bacaan direkod untuk ${student.name}!`);
            e.target.reset();

            if (onUpdate) {
                onUpdate(student);
            }
        } catch (error) {
            console.error("Gagal menyimpan kemajuan:", error);
            toast.error("Gagal simpan bacaan. Sila cuba lagi.");
        }
    };



    const surahOptions = surahData.map((surah, index) => ({
        label: surah.name,
        value: index,
    }));

    const handleMergeClick = async () => {
        const realId = prompt("Masukkan ID pelajar sebenar yang ingin merge:");
        if (!realId) return;

        try {
            await mergeManualWithRealStudent(student.id, realId);
            alert("Berjaya merge ke akaun sebenar.");
            onBack({ ...student, id: realId }); // refresh parent dengan ID baru
        } catch (error) {
            console.error("Gagal merge pelajar:", error);
            alert("Gagal merge. Sila semak ID atau cuba lagi.");
        }
    };

    const handleTouchStart = (e) => {
        if (e.touches && e.touches.length > 0) {
            setTouchStartX(e.touches[0].clientX);
        }
    };

    const handleTouchEnd = (e) => {
        if (touchStartX === null) return;

        const endX = e.changedTouches && e.changedTouches.length > 0
            ? e.changedTouches[0].clientX
            : touchStartX;
        const deltaX = endX - touchStartX;
        const threshold = 50; // px

        if (deltaX < -threshold && activeTab === "rekod") {
            // swipe kiri: pergi ke Rekod
            setActiveTab("semua");
        } else if (deltaX > threshold && activeTab === "semua") {
            // swipe kanan: balik ke Bacaan
            setActiveTab("rekod");
        }

        setTouchStartX(null);
    };

    // kira surah & ayat semasa untuk UI
    const isFirstTime = !student.progress?.length;
    const useCustomStart = isCustomStart && isFirstTime;


    const currentSurahIndex = useCustomStart
        ? customSurahIndex
        : student.currentSurahIndex;

    const currentSurah = surahData[currentSurahIndex] || null;

    const currentStartAyah = useCustomStart
        ? customStartAyah
        : student.startAyah;

    const totalAyahsCurrentSurah = currentSurah?.totalAyahs || currentStartAyah || 1;
    const nextAyah = currentStartAyah + 1;
    const isEndOfSurah = nextAyah > totalAyahsCurrentSurah;


    const presetUlasanList = [
        "Cemerlang! Tahniah",
        "Memuaskan. Usaha lagi.",
        "Perlu diperbaiki dari segi tajwid.",
        "Tidak lancar."
    ];

    const handlePresetUlasanClick = (text) => {
        setProgressForm((prev) => ({
            ...prev,
            ulasan: text
        }));
    };

    const handleDownloadClick = async () => {
        if (isGeneratingPdf) return; // elak double click

        try {
            setIsGeneratingPdf(true);
            await generateStudentPDF(student, schoolName, classroomName);
        } catch (err) {
            console.error("Gagal jana PDF:", err);
            toast.error("Gagal menjana PDF. Sila cuba lagi.");
        } finally {
            setIsGeneratingPdf(false);
        }
    };


    return (
        <>
            <div
                className="student-details-container"
                onTouchStart={handleTouchStart}
                onTouchEnd={handleTouchEnd}
            >


                <div className="student-detail-header">
                    {student.avatar ? (
                        <img
                            src={student.avatar}
                            alt="Student Avatar"
                            className="student-avatar-detail"
                        />
                    ) : (
                        <div className="initials-avatar-detail">
                            {getInitials(student.name)}
                        </div>
                    )}
                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "left", marginLeft: "10px", }}>
                        <div className="name-student">{student.name}</div>
                        <div className="juz-badge"><strong>{juz}</strong><br /> </div>
                    </div>


                    <div className="tab-switcher">
                        <div
                            className="tab-knob"
                            style={{
                                transform: activeTab === "rekod" ? "translateX(0)" : "translateX(100%)"
                            }}
                        ></div>

                        <button
                            className={activeTab === "rekod" ? "active-tab" : ""}
                            onClick={() => setActiveTab("rekod")}
                        >
                            Bacaan
                        </button>

                        <button
                            className={activeTab === "semua" ? "active-tab" : ""}
                            onClick={() => setActiveTab("semua")}
                        >
                            Rekod
                        </button>
                    </div>


                </div>





                <div className="tab-dots">
                    <span className={`tab-dot ${activeTab === "rekod" ? "active" : ""}`} />
                    <span className={`tab-dot ${activeTab === "semua" ? "active" : ""}`} />
                </div>




                {activeTab === "rekod" && (
                    <form onSubmit={handleSaveProgress} className="progress-form">
                        {!student.progress?.length && (
                            <div className="form-group">
                                <label>
                                    <input
                                        type="checkbox"
                                        checked={!isCustomStart}
                                        onChange={() => setIsCustomStart(prev => !prev)}
                                        style={{ transform: "scale(1.3)", marginRight: "8px" }}
                                    />
                                    Mula dari awal
                                </label>
                            </div>
                        )}

                        <div className="form-group">
                            {isCustomStart && !student.progress?.length ? (
                                <>
                                    <Select
                                        styles={customStyles}
                                        options={surahOptions}
                                        value={surahOptions.find(opt => opt.value === customSurahIndex)}
                                        onChange={(selected) => setCustomSurahIndex(selected.value)}
                                    />
                                </>
                            ) : (
                                <>
                                    Surah {surahData[student.currentSurahIndex]?.name || "Unknown Surah"}
                                    <span className="arabic-name">
                                        سورة {surahData[student.currentSurahIndex]?.arabicName || ""}
                                    </span>
                                </>
                            )}
                        </div>

                        <div className="flex-container">
                            <div className="child-flex">
                                <label htmlFor="startAyah">dari ayat</label>
                                <input
                                    type="number"
                                    id="startAyah"
                                    className={
                                        isCustomStart && !student.progress?.length
                                            ? "form-control-ayat"
                                            : "form-control-ayat-disable"
                                    }
                                    value={
                                        isCustomStart && !student.progress?.length
                                            ? customStartAyah
                                            : student.startAyah
                                    }
                                    onChange={(e) =>
                                        isCustomStart && !student.progress?.length &&
                                        setCustomStartAyah(Number(e.target.value))
                                    }
                                    disabled={!isCustomStart || !!student.progress?.length}
                                />


                            </div>

                            <div className="child-flex">
                                sehingga<br />
                                <select
                                    className="form-control-ayat select-ayat"
                                    name="endAyah"
                                    disabled={isEndOfSurah}
                                    value={progressForm.endAyah}
                                    onChange={(e) =>
                                        setProgressForm({ ...progressForm, endAyah: e.target.value })
                                    }
                                >
                                    {!isEndOfSurah &&
                                        Array.from(
                                            { length: totalAyahsCurrentSurah - nextAyah + 1 },
                                            (_, idx) => {
                                                const ayah = nextAyah + idx;
                                                return (
                                                    <option key={ayah} value={ayah}>
                                                        {ayah}
                                                    </option>
                                                );
                                            }
                                        )
                                    }
                                </select>

                            </div>


                        </div>


                        <div className="form-group">
                            <label htmlFor="ulasan">Ulasan</label>

                            <div className="preset-ulasan-container">
                                {presetUlasanList.map((text) => (
                                    <button
                                        key={text}
                                        type="button"
                                        className="preset-ulasan-chip"
                                        onClick={() => handlePresetUlasanClick(text)}
                                    >
                                        {text}
                                    </button>
                                ))}
                            </div>

                            <textarea
                                id="ulasan"
                                className="form-control-ulasan"
                                value={progressForm.ulasan || ""}
                                onChange={(e) =>
                                    setProgressForm({ ...progressForm, ulasan: e.target.value })
                                }
                                placeholder={`Tulis ulasan sendiri jika perlu... Jika dibiarkan kosong, ulasan "Bacaan yang baik" akan dipaparkan secara lalai`}
                            ></textarea>
                        </div>


                        <div className="button-group">

                            <button type="submit" className="save-button">
                                Simpan
                            </button>
                        </div>

                    </form>
                )}




                {activeTab === "semua" && (
                    <div className="progress-list">

                        <div style={{ display: "flex" }}>
                            <button
                                className={`toggle-icon ${isGeneratingPdf ? "disabled" : ""}`}
                                type="button"
                                onClick={handleDownloadClick}
                                disabled={isGeneratingPdf}
                            >
                                {isGeneratingPdf ? (
                                    <>
                                        <span className="pdf-spinner" />
                                        <span>Sedang jana PDF...</span>
                                    </>
                                ) : (
                                    <>
                                        <MdOutlinePictureAsPdf className="icon-button" />
                                        <span>Download</span>
                                    </>
                                )}
                            </button>



                            {student.isManualEntry && (
                                <button className="toggle-icon" type="button" onClick={handleMergeClick}>
                                    <MdOutlineCallMerge className="icon-button" />
                                    <span>Merge</span>
                                </button>
                            )}
                        </div>


                        <div className="accordion-container">

                            {student.progress?.map((item, idx) => (
                                <div key={idx} className="accordion-item">

                                    {/* HEADER */}
                                    <div
                                        className="accordion-header"
                                        onClick={() =>
                                            setOpenAccordion(openAccordion === idx ? null : idx)
                                        }
                                    >
                                        <span>
                                            {item.date} • {item.time || "-"}
                                        </span>

                                        <span className="accordion-icon">
                                            {openAccordion === idx ? <IoMdArrowDropup /> : <IoMdArrowDropdown />}
                                        </span>
                                    </div>


                                    {/* CONTENT */}
                                    {openAccordion === idx && (
                                        <div className="accordion-content">
                                            <p><strong>Surah:</strong> {item.surah}</p>
                                            <p><strong>Ayat:</strong> {item.startAyah} – {item.endAyah}</p>
                                            <p><strong>Guru:</strong> {item.guru || "-"}</p>
                                            <p><strong>Ulasan:</strong> {item.ulasan || "-"}</p>
                                        </div>
                                    )}
                                </div>
                            ))}

                        </div>
                    </div>
                )}



                <div className="detail-student">

                    <p className="student-detail-footnote">
                        {lastProgress ? (
                            <>
                                Bacaan terakhir pada {lastProgress.date}, {lastProgress.time}
                                <br />
                                Surah {lastProgress.surah}, Ayat {lastProgress.startAyah} - {lastProgress.endAyah}
                            </>
                        ) : (
                            <>Belum pernah membuat bacaan<br />Sila pilih bacaan pertama</>
                        )}
                    </p>


                </div>





            </div >
        </>

    );
};

export default StudentDetails;
